import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  ResourceMenuItems,
  useCopyToClipboardFeedback,
  type ResourceMenuAction,
} from "@coval/ui"
import { MoreHorizontal, Pencil, Trash2 } from "lucide-react"

interface NotebookMenuProps {
  notebookId: string
  href: string
  onRename: () => void
  onDelete: () => void
}

/** The standard resource dot menu for a notebook: rename, copy id/link, delete. */
export function NotebookMenu({
  notebookId,
  href,
  onRename,
  onDelete,
}: NotebookMenuProps) {
  const { copy } = useCopyToClipboardFeedback()
  const actions: ResourceMenuAction[] = [
    { label: "Rename", icon: <Pencil />, onSelect: onRename },
    {
      label: "Delete",
      icon: <Trash2 />,
      destructive: true,
      onSelect: onDelete,
    },
  ]
  const url =
    typeof window === "undefined"
      ? href
      : new URL(href, window.location.origin).toString()
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" aria-label="Notebook actions">
          <MoreHorizontal className="h-4 w-4" aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <ResourceMenuItems
          actions={actions}
          copy={{ id: notebookId, url }}
          onCopy={(value) => void copy(value)}
          item={DropdownMenuItem}
          separator={DropdownMenuSeparator}
        />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
